import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getId } from '../../utils/helperMethods';
import './timeline.scss';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import checkGreen from "../../static/images/checkGreen.png";
/* 
Stages - 
Completed - filled form - editable,
Open - new form - editable
Tobefilled - non clickable icon - editable
 */
const Timeline = ({ onboardingProcess, isCreate, heading }) => {
    const location = useLocation();
    const path  = location?.pathname || "";
    // console.log("current location contains", location, path);
    return (
        <>
            <div className="timelinev1wrap">
                {heading && <p>{heading}</p>}
                <ul className="timelinev1">
                    {onboardingProcess.map(merchantOnboard => {
                        // console.log("inisdeß TimeLine --> onBoarding", merchantOnboard);
                        return (
                            <li
                                id={getId(merchantOnboard.name)}
                                className={`event ${merchantOnboard.status} ${path.includes(merchantOnboard.path) ? 'selected' : ''} ${merchantOnboard.disabled ? 'disabled' : ''}`}
                                key={merchantOnboard.tabId}
                            >
                                {/* {merchantOnboard.status !== 'Complete' &&
                                merchantOnboard.status !== 'Open' ? (
                                    <h3>{merchantOnboard.name}</h3>
                                ) : ( */}
                                    <Link
                                        // className={isCreate ? 'disabled' : ''}
                                        to={merchantOnboard.path}
                                    >
                                        <h3>{merchantOnboard.name}
                                            {merchantOnboard.status === 'Complete' && 
                                                <img className='success-icon-timeline' src={checkGreen} alt="Success"  />
                                            }
                                        </h3>
                                    </Link>
                                {/* )} */}
                            </li>
                        );
                    })}
                </ul>
            </div>
        </>
    );
};

Timeline.propTypes = {
    isCreate: PropTypes.bool,
    onboardingProcess: PropTypes.array.isRequired,
};

export default Timeline;
